// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SxGT","delete":"styles_delete__3R0BD","update":"styles_update__ySzJX","add":"styles_add__BPARL"};